import { isObject, isString } from '@fabric-app/utils/guards';
import { ErrorType } from './errors.types.js';

const isErrorOfType = (errorType, error) => {
  if (!error || !isObject(error) || !isWoodyError(error)) return false;
  return error.detail === errorType;
};
const getErrorStatus = (error) => {
  if (typeof error === "object" && !!error && "status" in error && typeof error.status === "number") {
    return error.status;
  }
  return null;
};
const getErrorDetail = (error) => {
  if (isObject(error) && "detail" in error && typeof error.detail === "string") {
    return error.detail;
  }
  return void 0;
};
const getErrorMessage = (error) => {
  if (isObject(error) && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return void 0;
};
const getErrorType = (error) => {
  if (!error || !isObject(error) || !isWoodyError(error)) return null;
  return Object.values(ErrorType).find((type) => type === error.detail) || null;
};
const isWoodyError = (value) => {
  if (!value || typeof value !== "object") return false;
  return "status" in value && "title" in value;
};
const isErrorType = (value) => {
  return isString(value) && Object.values(ErrorType).includes(value);
};

export { getErrorDetail, getErrorMessage, getErrorStatus, getErrorType, isErrorOfType, isErrorType, isWoodyError };
//# sourceMappingURL=errors.utils.js.map
